<template>
  <div class="login-page">
    <div class="login-card soft-card">
      <div class="brand">智慧小广</div>
      <div class="sub">后台管理系统</div>
      <el-form
        ref="loginForm"
        :model="form"
        :rules="rules"
        class="login-form"
        @keyup.enter.native="submit"
      >
        <el-form-item prop="username">
          <el-input
            v-model="form.username"
            clearable
            prefix-icon="el-icon-user"
            placeholder="管理员账号"
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="form.password"
            clearable
            show-password
            prefix-icon="el-icon-lock"
            placeholder="管理员密码"
          />
        </el-form-item>
        <el-button
          type="primary"
          class="login-btn"
          :loading="loading"
          @click="submit"
        >
          登录
        </el-button>
      </el-form>
      <div class="form-tip">忘记密码请联系运维人员重置，系统不保存明文密码。</div>
    </div>
  </div>
</template>

<script>
import { login } from '../api'

export default {
  data() {
    return {
      loading: false,
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ required: true, message: '请输入管理员账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入管理员密码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    submit() {
      this.$refs.loginForm.validate(valid => {
        if (!valid) {
          return
        }
        this.loading = true
        login(this.form)
          .then(res => {
            localStorage.setItem('adminToken', res.token)
            localStorage.setItem('adminUser', JSON.stringify(res))
            this.$message.success('登录成功')
            this.$router.replace('/')
          })
          .finally(() => {
            this.loading = false
          })
      })
    }
  }
}
</script>

<style scoped>
.login-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #edf7ff, #f8fbff);
}

.login-card {
  width: 420px;
  padding: 42px;
  text-align: center;
}

.brand {
  color: #2f6f9f;
  font-size: 34px;
  font-weight: 900;
}

.sub {
  margin: 10px 0 30px;
  color: #7a8798;
}

.login-btn {
  width: 100%;
  height: 44px;
  border-radius: 12px;
  font-weight: 700;
}

.form-tip {
  margin-top: 18px;
  padding: 10px 14px;
  border-radius: 12px;
  background: #f5f8fb;
  color: #8a98aa;
  font-size: 12px;
  line-height: 1.6;
  text-align: left;
}
</style>
